module.exports = __webpack_public_path__ + "img/pause--encircled.f8feb838.svg";